import { render, staticRenderFns } from "./WorkflowActionDaysBeforePartial.vue?vue&type=template&id=48ba8c38&scoped=true&"
import script from "./WorkflowActionDaysBeforePartial.vue?vue&type=script&lang=ts&"
export * from "./WorkflowActionDaysBeforePartial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba8c38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadioGroup,VRow})
